module.exports = __webpack_public_path__ + "static/go-logo-b23e2c8a0cf4686a56b7a69e08bdc40c.png";